import {alignBelowAnnotations, mergeAnnotations} from "./utils";

export default class Preview {
    constructor(settings, mediator) {
        this.settings = {
            ...settings
        }
        this.mediator = mediator;
        this.initEditor();
    }

    initEditor() {
        this.annotations = [];
        this.previewAnnotations = {
            annotations: []
        };

        this.protocolAnnotations = {
            context: {
                pk: null,
                type: null,
            },
            annotations: []
        };

        this.restrictionEnzymes = [];

        this.hiddenRestrictionEnzymes = [];
        this.hiddenAnnotations = [];

        this.slots = [];

        this.initPosition = 0;

        this.offsetScroll = {
            "current": 0,
            "step": 0,
        }
    }

    initDataSequence(data) {
        this.srcData = {
            slots: data.slots || []
        };

        this.sequenceLength = parseInt(data.sequence.length);

        this.maxBelowLevel = -1;
        this.maxAboveLevel = -1;

        [this.annotations, this.maxBelowLevel, this.maxAboveLevel] = alignBelowAnnotations(mergeAnnotations(data, this.previewAnnotations, this.protocolAnnotations, this.sequenceLength, this.hiddenAnnotations));
        this.initYPosition = 30;
    }

    toggleItems(data) {
        if (data.selector === "restrictionEnzymes") {
            this.restrictionEnzymes.forEach(el => {
                if (data.objects.includes(el.id)) {
                    if (!data.visible) {
                        this.hiddenRestrictionEnzymes.push(el.id)
                    } else {
                        this.hiddenRestrictionEnzymes = this.hiddenRestrictionEnzymes.filter(item => item !== el.id)
                    }
                    el.visible = data.visible;

                    this.previewBox.selectAll(".restEnzyme_" + el.id)
                        .style("opacity", data.visible ? 1 : 0);
                }
            })
        } else {
            this.annotations.forEach(el => {
                if (data.objects.includes(el.pk)) {
                    if (!data.visible) {
                        this.hiddenAnnotations.push(el.pk)
                    } else {
                        this.hiddenAnnotations = this.hiddenAnnotations.filter(item => item !== el.pk)
                    }

                    el.visible = data.visible;
                    this.previewBox.selectAll(".annotation_" + el.pk)
                        .style("opacity", data.visible ? .6 : 0);
                }
            })
        }
    }

    setContextEditor(context) {
        this.protocolAnnotations.context.pk = context.pk;
        this.protocolAnnotations.context.type = context.type;
    }

    EventsTrigger(action, data) {
        if (this.mediator) {
            this.mediator.trigger(action, data, this)
        }
    }

    EventsOn() {
        if (this.mediator) {
            this.mediator.on("setContextEditor", "setContextEditor", this);
        }
    }
}